import { Link } from 'react-router-dom';
import { type MenuItem } from '@/types/common';
import AccountChip from '@/components/AccountChip';
import Navigation from '@/components/Navigation';
import Swipesign from '@/assets/logo/Swipesign.svg?react';
import styles from './Sidebar.module.scss';

interface SidebarProps {
  /** Items already filtered for the current user's permissions. */
  menuItems: MenuItem[];
}

// Items that live in the account chip popover (and the mobile More sheet's
// MY PROFILE / HELP & PREFERENCES sections) — anything tagged with one of
// those sections, plus the logout action. Driven by menuApp metadata so we
// don't have to know which paths exist.
const isAccountAreaItem = (item: MenuItem) =>
  item.action === 'logout' ||
  item.mobileSection === 'profile' ||
  item.mobileSection === 'help';

const Sidebar = ({ menuItems }: SidebarProps) => {
  // The main nav rail excludes anything that lives in the account chip.
  const railItems = menuItems.filter((item) => !isAccountAreaItem(item));

  return (
    <aside className={styles.sidebar}>
      <Link to="/dashboard" className={styles.brand} aria-label="Swipesign">
        <Swipesign className={styles.logo} />
      </Link>
      <Navigation menuItems={railItems} />
      <AccountChip allMenuItems={menuItems} />
    </aside>
  );
};

export default Sidebar;
